import { FC, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { handleCompanyUrl } from 'utils/organizationUtils';

const ZoomAuth: FC = observer(() => {
  const location = useLocation();
  const history = useHistory();
  const {
    AppStore: { zoomAuthConnected },
    notificationStore: { openNotification },
  } = useStore();

  useEffect(() => {
    if (location.search) {
      zoomRequest.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const zoomRequest = useMutation(() => zoomAuthConnected(location.search), {
    onSuccess: (data: any) => {
      if (data) {
        history.push(handleCompanyUrl('/apps/zoom'));
      } else {
        history.push(handleCompanyUrl('/dashboard'));
      }
    },
    onError: ({ message }: Error) => openNotification('error', message ? message : 'Something went wrong'),
  });

  useAppPreloader(zoomRequest.isLoading);

  return <></>;
});

export default ZoomAuth;
